import qsa from '../../scripts/util/DOM/qsa';
import qs from '../../scripts/util/DOM/qs';
import {build, compile} from '../../scripts/renderTemplate';
import select from '../filter/filter';
import isElem from '../../scripts/util/isElement';
import {forEach} from 'ramda';
import fixedFilter from './fixedFilter';
import {refreshFilterPosition} from './fixedFilter';
import $ from 'jquery';

const selectors = {
	clients: '.clients',
	json: '#clients-json',
	previewTmp: '#preview-tmp',
	content: '#content',
	preview: '.clients__preview',
	showMore: '.js--clients__button-more'
};

const classes = {
	fade: 'clients__preview_fade',
	hide: 'hide'
};


let values = [];
let loadingFlag = false;
let stayScrollTop;

const element = $(selectors.previewTmp).clone()[0];
const fade = elem => elem.classList.remove(classes.fade);
const fadeAll = forEach(fade);

const animate = () => {
	const previews = qsa(selectors.preview);
	setTimeout(() => {
		fadeAll(previews);
	}, 300);
};

const insert = (block, output) => {
	block.innerHTML = output.join(' ');
	animate();
	refreshFilterPosition();
};

const append = (block, output) => {
	output.map(item => {
		const div = document.createElement('span');
		div.innerHTML = item;
		block.appendChild(div.firstElementChild);
	});
	animate();
	refreshFilterPosition();
};

const loadExamples = data => {
	const areas = data.areas;
	$.ajax({
		url: '/clients/chunk',
		type: 'POST',
		data: {
			areas,
			offset: data.offset,
			count: data.count,
			_csrf: $('meta[name="csrf-token"]').prop('content')
		},
		dataType: 'json',
		cache: false,
		success: jsonResult => {
			const response = jsonResult.sites;

			if (response.length > 0) {
				const container = qs(selectors.content);
				const template = compile(element);
				build(template, response, container, data.filter ? insert : append)();
				loadingFlag = false;
				$(window).scrollTop(stayScrollTop);

				if (data.trigger === true) {
					$(selectors.showMore).removeClass('is--hide');
				} else {
					document.dispatchEvent(new Event('refresh-filter-position'));
				}
				if (response.length < 8) {
					$(selectors.showMore).addClass('is--hide');
				}
			}
		}
	});
};

const initScrollEvent = () => {
	stayScrollTop = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop;
};

const getDataElementsOnClick = data => {
	if (loadingFlag !== true) {
		loadingFlag = true;

		const dataElements = data || {
			areas: values,
			offset: $(selectors.preview).length,
			count: 8,
			filter: false
		};

		initScrollEvent();
		loadExamples(dataElements);
	}
};

const clickShowMore = data => {
	$(selectors.showMore).on('click', function (e) {
		e.preventDefault();
		getDataElementsOnClick(data);
	});
};

const getAjaxData = (areas, settings, filter) => {
	loadingFlag = false;
	const data = {
		areas,
		offset: settings.offset,
		count: settings.count,
		filter,
		trigger: true
	};
	loadExamples(data);
	clickShowMore(data);
};

const getData = () => {
	const data = $(selectors.json).length ? JSON.parse($(selectors.json).html()) : [];
	const container = qs(selectors.content);
	const template = compile(element);

	loadingFlag = false;
	clickShowMore();
	build(template, data, container, insert)();
};

const filter = areas => {
	stayScrollTop = $('.js-filter-box').offset().top - $('.js-header').height() - 60;
	getAjaxData(areas, {offset: 0, count: 8}, true);
};

const setValues = data => {
	values = data;
	filter(data);
};

const render = () => {
	if (isElem(selectors.clients)) {
		getData();
		select(setValues);
		fixedFilter();
	}
};

export default render;
